<template>
    <div id="addToCart" class="mt-lg-2 mx-2 mx-md-0 pb-2 pb-lg-3" :class="{ 'not' : pieces.length < 1}" v-if="pieces.length >= 1">
        <div class="rounded-bottom-10">
            <div class="bg-gris-pro rounded-10">
                <transition name="bounce">
                    <div id="total" class="pb-0 pb-md-3 px-0 bg-gris-pro rounded-10">

                        <b-button variant="link" class="w-100 justify-content-between align-items-center py-2 mt-0 mt-md-2 choice rounded-top-10 d-flex" :class="[{'gris' : pieces.length >= 1}, {'active' : mobile || isSidebarDropped != 'settings' && !mobile || !isSidebarDropped && pieces.length > 0 && !mobile}]">
                            <div class="d-flex align-items-center">
                                <b-icon class="mr-2" icon="aspect-ratio" font-scale="1.3" />
                                <span class="mb-0 p-0 d-flex">
                                    <t class="font-weight-bold animated fadeIn" addtocart.yourPieces /><span class="p-0 pl-1 font-weight-bold" v-if="isSidebarDropped != 'settings'"> - {{totalPrice ? totalPrice.toFixed(2) : "0.00"}} € <small><t addToCart.Ttc /></small></span>
                                </span>
                            </div>
                            <b-icon class="d-none d-md-block" icon="caret-down-fill" font-scale=".95" />
                        </b-button>

                        <div class="mx-0 px-2 px-md-0 mx-md-3 pt-2 pt-md-3 pb-2 pb-md-0 border-gris-pro rounded-bottom-10 border-5">
                            <div id="cart-article" class="rounded-10 d-flex flex-column">
                                <materials-choice v-if="!mobile" />
                                    
                                <transition-group name="bounce">

                                    <div id="composition" class="overflow-hidden order-0 order-md-1" v-if="isSidebarDropped != 'settings' || pieces.length == 1 || mobile" key="composition">
                                        <div class="bg-gris-pro rounded-10 px-0">
                                            <div v-for="piece in uniquePieces" v-bind:key="piece.name" class="border-0 rounded-0 bg-transparent px-0 pt-1"  :class="{'sizeInvalid' : piece.validSize == false}">
                                                <div class="bg-white rounded-10 d-flex mx-1 mx-md-0">
                                                    <div class="d-flex col-8 p-0 my-1">
                                                        <div v-if="piece.svg" vertical-align="center" v-html="piece.svg" class="thumbnail h-100 bg-gris-pro p-2 ml-1 rounded-10 d-flex align-items-center position-relative texture" @click="zoomThumbnail(); thumbnail = piece.svg"></div>
                                                        <div class="pl-2 col-8 col-sm-10 pr-2 py-1">
                                                            <span class="d-flex h-100">
                                                                <span class="small font-weight-bold d-flex justify-content-between flex-column">
                                                                    <div>

                                                                        <div class="d-flex align-items-center" v-if="piece.validSize">
                                                                            <b-icon icon="crop" font-scale="1" />
                                                                            <span v-if="piece.global_shape == 'circle'" class="ml-1 line-height">{{Math.round(parseFloat(piece.width) * 10) /10}} <t addToCart.mm /> x {{Math.round(parseFloat(piece.height) * 10) / 10}} <t addToCart.mm /></span>
                                                                            <span v-else class="ml-1 line-height">{{Math.round(parseFloat(piece.width))}} <t addToCart.mm /> x {{Math.round(parseFloat(piece.height))}} <t addToCart.mm /></span>
                                                                        </div>
                                                                        <div class="d-flex" v-else>
                                                                            <span class="alert rounded-10 px-2 py-1 mt-1 mb-1 d-block font-weight-bold">
                                                                                <t addToCart.tooBig v-if="piece.width >= cuttingOptions.maximalWidth || piece.height >= cuttingOptions.maximalHeight || piece.boundingArea > cuttingOptions.minimalArea" />
                                                                                <t addToCart.tooSmall v-else />
                                                                                <b-icon icon="info-circle-fill" font-scale="1.2"  @click="tutorial('out-of-dimension', piece.name)" />
                                                                                <transition-group name="bounce" v-if="!piece.validSize">
                                                                                    <div class="fly-over-alert position-relative font-weight-normal pb-1" v-if="tuto == 'out-of-dimension' && piecename == piece.name || mobile" key="tuto" @click="tuto = null">
                                                                                        <div class="line-height mt-1 text-dark">
                                                                                            <span class="font-weight-bold mb-1 d-flex"><b-icon icon="crop" font-scale="1" />
                                                                                                <span v-if="piece.global_shape == 'circle'" class="ml-1">{{Math.round(parseFloat(piece.width) * 10) /10}} <t addToCart.mm /> x {{Math.round(parseFloat(piece.height) * 10) / 10}} <t addToCart.mm /></span>
                                                                                                <span v-else class="ml-1">{{Math.round(parseFloat(piece.width))}} <t addToCart.mm /> x {{Math.round(parseFloat(piece.height))}} <t addToCart.mm /></span>
                                                                                            </span>

                                                                                            <div id="alert-too-big" v-if="piece.width >= cuttingOptions.maximalWidth || piece.height >= cuttingOptions.maximalHeight">
                                                                                                <t addToCart.tutoOutOfDimension />
                                                                                                <span class="font-weight-bold mt-1 d-block">{{cuttingOptions.maximalWidth}} x {{cuttingOptions.maximalHeight}}<t addToCart.mm /></span>
                                                                                            </div>
                                                                                            <div id="alert-too-small" v-if="(piece.width <= cuttingOptions.minimalWidth || piece.height <= cuttingOptions.minimalHeight) || piece.boundingArea < cuttingOptions.minimalArea">
                                                                                                <t addToCart.tutoOutOfDimension />
                                                                                                <span class="font-weight-bold mt-1 d-block">{{cuttingOptions.minimalWidth}} x {{cuttingOptions.minimalHeight}}<t addToCart.mm /></span>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </transition-group>
                                                                            </span>
                                                                        </div>

                                                                        <div class="d-flex" v-if="piece.validSize">
                                                                            <img :src="require( '@/assets/img/poids.svg')" height="15px">
                                                                            <span class="ml-1">{{Math.round(parseFloat(piece.weight) * 100) / 100}} <t addToCart.kg /></span>
                                                                        </div>
                                                                    </div>

                                                                    <div class="d-flex align-items-end" v-if="piece.validSize">
                                                                        <div class="cart_quantity_button cursor-pointer" @click="changeQuantity(piece, -1)">
                                                                            <a rel="nofollow" :class="{'disabled': (piece.quantity == piece.copies.length + 1)}" class="cart_quantity_down button-minus d-flex align-items-center" title="Subtract">
                                                                                <svg class="icon-gris" width="15" height="15"><use xlink:href="/themes/johnsteel/assets/img/sprite.svg#fa-minus"></use></svg>
                                                                            </a>
                                                                        </div>
                                                                        <div class="number-product">
                                                                            <input class="text-center py-1 border-0 font-weight-bold bg-transparent rounded-10" :style="'width:' + (piece.quantity.toString().length + 2)  + 'ch'" type="text" :min="piece.copies.length + 1" v-model="piece.quantity" @input="onChange(piece)" name="product-quantity-spin">
                                                                        </div>
                                                                        <div class="cart_quantity_button d-flex cursor-pointer" @click="changeQuantity(piece, 1)">
                                                                            <a rel="nofollow" class="cart_quantity_up button-plus d-flex align-items-center" title="Add">
                                                                                <svg class="icon-gris" width="15" height="15"><use xlink:href="/themes/johnsteel/assets/img/sprite.svg#fa-plus"></use></svg>
                                                                            </a>
                                                                        </div>
                                                                    </div>
                                                                </span>
                                                            </span>
                                                        </div>
                                                    </div>

                                                    <div class="col-4 p-0 d-flex flex-column justify-content-between">                            
                                                        <span class="price-block d-block text-dark font-weight-bold price text-right pr-2 pb-1 line-height" v-if="piece.validSize">{{piece.price ? piece.price.toFixed(2) : "0.00"}} € <span class="small-50"><t addToCart.Ttc /></span></span>
                                                    </div>
                                                </div>
                                                <div class="w-100 text-right" v-if="piece.decreasing && piece.validSize && piece.decreasing !='0 %'">
                                                    <span class="small text-violet font-weight-bold pr-2 pr-md-0"><t addToCart.degressivity /> {{piece.decreasing}}</span>
                                                </div>
                                            </div>
                                            <div id="alertQty" class="rounded-10 bg-white px-2 p-2 mt-2 font-weight-bold" v-if="displayAlertQty">
                                                <b-icon class="mr-2" icon="info-circle-fill" font-scale="1.2"/>
                                                <t addToCart.alertQty />
                                            </div>
                                        </div>
                                    </div>
                                </transition-group>
                            </div>
                            <transition-group name="bounce" key="div">
                                <div id="open-cart" class="bg-white rounded-10 font-weight-bold d-flex align-items-center justify-content-center cursor-pointer mt-1 py-3" v-if="pieces.length > 1 && isSidebarDropped == 'settings' && !mobile" key="open-cart">
                                    <div class="position-relative">
                                        <b-icon icon="cart3" font-scale="2.3" />
                                        <span id="total-cart">{{pieces.length}}</span>
                                    </div>
                                    <span class="mb-0 font-weight-bold h4" :class="isSidebarDropped == 'addtocart' ? 'ml-2' : 'ml-3'">{{totalPrice ? totalPrice.toFixed(2) : "0.00"}} €<span class="extra-small"><t addToCart.Ttc /></span></span>
                                </div>
                            </transition-group>
                        </div>
                    </div>
                </transition>
            </div>
        </div>

        <button id="addtocart" class="btn addtocart d-block rounded-10 w-100 mb-2 mb-md-0 p-0" :class="[isSidebarDropped == 'addtocart' ? 'mt-3' : 'mt-3', pieces.length >= 1 ? 'btn-vert' : 'btn-disabled']" @click="submit('addtocart')"  v-if="oneValidSize && thicknessPsid">
            <span class="font-weight-bold">
                <img :src="require( '@/assets/img/express-order.svg')">
                <t class="ml-1" addToCart.order />
            </span>
            <div class="load">
                <div class="d-flex align-items-center justify-content-center">
                    <svg width="29px" height="29px">
                        <path d="M8.219 21.781c0 1.094-0.891 2-2 2-1.094 0-2-0.906-2-2 0-1.109 0.906-2 2-2 1.109 0 2 0.891 2 2zM16 25c0 1.109-0.891 2-2 2s-2-0.891-2-2 0.891-2 2-2 2 0.891 2 2zM5 14c0 1.109-0.891 2-2 2s-2-0.891-2-2 0.891-2 2-2 2 0.891 2 2zM23.781 21.781c0 1.094-0.906 2-2 2-1.109 0-2-0.906-2-2 0-1.109 0.891-2 2-2 1.094 0 2 0.891 2 2zM8.719 6.219c0 1.375-1.125 2.5-2.5 2.5s-2.5-1.125-2.5-2.5 1.125-2.5 2.5-2.5 2.5 1.125 2.5 2.5zM27 14c0 1.109-0.891 2-2 2s-2-0.891-2-2 0.891-2 2-2 2 0.891 2 2zM17 3c0 1.656-1.344 3-3 3s-3-1.344-3-3 1.344-3 3-3 3 1.344 3 3zM25.281 6.219c0 1.937-1.578 3.5-3.5 3.5-1.937 0-3.5-1.563-3.5-3.5 0-1.922 1.563-3.5 3.5-3.5 1.922 0 3.5 1.578 3.5 3.5z"></path>
                    </svg>
                    <p class="mb-0 d-md-none font-weight-bold ml-2 text-white"><t addToCart.addToCart /></p>
                </div>
            </div>
        </button>
        <button id="express-addtocart" class="btn addtocart d-block rounded-10 w-100 mb-2 mb-md-0 mt-2 p-0" :class="pieces.length >= 1 ? 'btn-gris bg-gris-pro' : 'btn-disabled'" @click="newPiece()" v-if="oneValidSize && thicknessPsid">
            <span class="font-weight-bold text-dark">
                <img :src="require( '@/assets/img/add-piece.svg')">
                <t class="ml-1" addToCart.orderExpress />
            </span>
            <div class="load">
                <div class="d-flex align-items-center justify-content-center">
                    <svg width="29px" height="29px">
                        <path d="M8.219 21.781c0 1.094-0.891 2-2 2-1.094 0-2-0.906-2-2 0-1.109 0.906-2 2-2 1.109 0 2 0.891 2 2zM16 25c0 1.109-0.891 2-2 2s-2-0.891-2-2 0.891-2 2-2 2 0.891 2 2zM5 14c0 1.109-0.891 2-2 2s-2-0.891-2-2 0.891-2 2-2 2 0.891 2 2zM23.781 21.781c0 1.094-0.906 2-2 2-1.109 0-2-0.906-2-2 0-1.109 0.891-2 2-2 1.094 0 2 0.891 2 2zM8.719 6.219c0 1.375-1.125 2.5-2.5 2.5s-2.5-1.125-2.5-2.5 1.125-2.5 2.5-2.5 2.5 1.125 2.5 2.5zM27 14c0 1.109-0.891 2-2 2s-2-0.891-2-2 0.891-2 2-2 2 0.891 2 2zM17 3c0 1.656-1.344 3-3 3s-3-1.344-3-3 1.344-3 3-3 3 1.344 3 3zM25.281 6.219c0 1.937-1.578 3.5-3.5 3.5-1.937 0-3.5-1.563-3.5-3.5 0-1.922 1.563-3.5 3.5-3.5 1.922 0 3.5 1.578 3.5 3.5z" fill="#343a40"></path>
                    </svg>
                    <p class="mb-0 d-md-none font-weight-bold ml-2 text-dark"><t addToCart.addToCartExpress /></p>
                </div>
            </div>
        </button>

        <b-modal id="modal-thumbnail" ref="modal-thumbnail" size="md" content-class="bg-gris-pro" centered modal-ok="test">
            <div id="thumbnail-img" class="texture" v-html="thumbnail"></div>
            <template #modal-footer="{ ok }">
                <b-button @click="ok()">
                    <t addToCart.closeModalThumbnail />
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import store from '../../store';
    import MaterialsChoice from './MaterialsChoice.vue';
    import { BModal, VBModal, BIcon, BIconAspectRatio, BIconCloudDownload, BIconCrop, BIconCaretDownFill, BButton, BIconCreditCard2BackFill, BIconCart3, BIconInfoCircleFill, BIconExclamationTriangleFill } from 'bootstrap-vue';

    export default {
        components: {
            BIcon,
            // eslint-disable-next-line vue/no-unused-components
            BModal, VBModal, BIconAspectRatio, BIconCloudDownload, BIconCrop, BIconCaretDownFill, BButton, BIconCreditCard2BackFill, BIconCart3, BIconInfoCircleFill, BIconExclamationTriangleFill, MaterialsChoice
        },
        directives: {'b-modal': VBModal},

        data(){
            return {
                tuto: null,
                piecename: null,
                event: null,
                isQuantityChanged: false,
                displayAlertQty: false,
                thumbnail: null
            }
        },

        computed: {
            ...mapGetters([
                'pieces',
                'totalPrice',
                'isSidebarDropped',
                'cuttingOptions',
                'thicknessPsid',
                'mobile',
                'showAlertQuantity'
            ]),
            uniquePieces: function() {
                return this.pieces ? this.pieces.filter(p => !p.isCopyOf) : []
            },
            oneValidSize: function(){
                return this.pieces.some((piece) => piece.validSize);
            }
            
        },
        watch:{
            totalPrice: async function() {
                if(this.isQuantityChanged && this.showAlertQuantity){
                    this.displayAlertQty = true;
                }
            }
        },

         methods: {
            submit(btn,express = false) {
                this.$store.dispatch('submit', express);
                document.querySelector('#' + btn).classList.add('loading');

                const buttons = document.getElementsByClassName('addtocart');
                for (let i = 0; i < buttons.length; i++) {
                    buttons[i].disabled = true;
                }
                if (window.innerWidth > 768) {
                    store.dispatch('setLoadingStep', this.$t('addToCart.loadingAddToCart'));
                }
            },
            setSidebarDropped(element) {
                this.$store.dispatch('setIsSidebarDropped', element);
            },
            tutorial(element, piece) {
                if (this.tuto != element || this.piecename != piece) {
                    this.tuto = element;
                    this.piecename = piece;
                } else {
                    this.tuto = null;
                    this.piecename = null;
                }
            },
            newPiece(){
                document.querySelector('#express-addtocart').classList.add('loading');
                let id_composition = this.$store.getters.compositionId;
                let id_product = this.$store.getters.productPsid;
                let id_thickness = this.$store.getters.thicknessPsid;
                if(window.obelix.onNewPiece) window.obelix.onNewPiece(id_composition, id_product, id_thickness);
            },

            async updateQuantity(event, piece){
                this.validateQuantity = false;
                if(piece.quantity > 0){
                    let quantity = piece.quantity;
                    await this.$store.dispatch('setQuantity',{quantity, piece});
                    this.isQuantityChanged = true;
                }
            },

            onChange(piece){
                let value = parseInt(piece.quantity);
                let min = parseInt(piece.copies.length) + 1;
                if (value < min || isNaN(value)) {
                    piece.quantity = min;
                }
                this.updateQuantity(null, piece);
            },

            changeQuantity(piece, symbol){
                let old_quantity = piece.quantity;
                let value = parseInt(piece.quantity) + symbol;
                let min = parseInt(piece.copies.length) + 1;
                if (value < min || isNaN(value)) {
                    piece.quantity = min;
                }else{
                    piece.quantity = value;
                }
                if(old_quantity != piece.quantity){
                    this.updateQuantity(null, piece);
                }
            },

            zoomThumbnail() {
                this.$refs['modal-thumbnail'].show();
            }
        }
    }
</script>

<style lang="scss">
    @import './../../assets/scss/_variables.scss';

    .choice {
        color: $white!important;
    }

    .border-5 {
        border-width: 0!important;

        @media (max-width: 768px) {
            border-width: 5px!important;
        }
    }

    #addToCart {
        .title-dropdown {
            @media (max-width: 768px) {
                font-size: 1.15rem;
            }
        }
        >.bg-gris {
            @media (min-width: 768px) {
                background: $white!important;
            }

            >.bg-gris-pro {
                @media (min-width: 768px) {
                    background: $white!important;
                }
            }
        }
        .bi-info-circle-fill {
            cursor: pointer;
            transition: all .3s ease-in-out;

            &:hover {
                @media (min-width: 576px) {
                    transform: scale(1.3) rotate(15deg);
                }
            }
        }
    }

    #mobile-cart {
        &.show {
            border-radius: 10px 10px 0 0;

            ~ .bg-gris {
                border-radius: 10px 0 10px 0px!important;
            }
        }
        .dropdown-menu {
            z-index: -1;
            transform: translate3d(-5px,56px, 0px)!important;
        }
    }

    #composition {
        .choice {
            border-radius: 10px;
            background: $gris-btn;
            cursor: pointer;

            &.active {
                background: $rose;
                border-radius: 10px 10px 0 0;
            }

            @media (max-width: 768px) {
                border-radius: 10px 0 10px 10px;
            }
        }
        .col-10 {
            z-index: 2;
        }
    }

    #open-cart {
        * {
            transition: all .3s ease-in-out;
        }

        &.piece:hover,
        &.active {
            svg {
                transform: rotate(-15deg) translate(5px);
            }

            #total-cart {
                transform: translate(2px, -10px) scale(1.2);
            }

            span {
                transform: translate(5px);
            }
        }

        @media (max-width: 768px) {
            background: transparent!important;
        }
    }

    .small-50 {
        font-size: 50%;
    }

    #total {
        @media (max-width: 768px) {
            background: $white!important;
        }

        #cart-article {
            @media (max-width: 768px) {
                background: $grispro!important;
            }
        }

        .choice.gris {
            background: #a39797;

            &.active {
                background: $rose;

                @media (max-width: 768px) {
                    border-radius: 10px 0 0 0!important;
                }
            }
        }
    }

    #total-cart {
        background: $jaune;
        width: 22px;
        height: 22px;
        padding: 2px 7px;
        font-size: 80%;
        border-radius: 50%;
        color: white;
        position: absolute;
        right: -5px;
        top: -5px;
    }

    #addtocart,
    #express-addtocart {
        div {
            display: none;
        }
        &:disabled {
            opacity: 1!important;
        }
    }
    
    #express-addtocart {
        @media (max-width: 768px) {
            background: #f3f3f3!important;
        }
    }

    .loading {
        span {
            padding: 0!important;

            * {
                display: none;
            }
        }
        .load {
            display: block!important;
            padding: 7px;

            svg {
                fill: $white;
                animation: rotating 1.5s linear infinite;
            }
        }
    }

    .price {
        white-space: nowrap;
        font-size: 1.2rem;

        @media (max-width: 576px) {
            font-size: 1rem;
        }
    }

    .extra-small {
        font-size: 60%;
        margin-left: 5px;
    }

    .btn-disabled {
        background: $gris-btn;
        padding: 0;
        opacity: .5;
        cursor: not-allowed!important;
    }

    #addtocart {
        background: rgb(163 151 151 / 30%);
    }

    .not {
        opacity: .5;
    }

    .small img {
        height: 15px!important;
        fill: $dark;
    }

    .sizeInvalid {
        .thumbnail {
            svg path {
                fill: $grispro;
                stroke: $violet;
            }
        }

        .alert {
            color: $rose;
            border: 2px solid $rose;
            z-index: 2;
        }
    }

    .thumbnail {
        cursor: pointer;

        &:hover:after {
            content: url(./../../assets/img/loupe.svg);
            width: 30px;
            height: 30px;
            position: absolute;
            top: 0;
            bottom: 0;
            right: 0;
            left: 0;
            margin: auto;
        }
    }

    .bi-exclamation-octagon-fill {
        fill: $rose;
    }

    @keyframes rotating {
        from {
            transform: rotate(0);
        }
        to {
            transform: rotate(360deg);
        }
    }
        
    #quantity{
        -moz-appearance: textfield;
        &::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin:0;
        }
        &::-o-inner-spin-button {
            -o-appearance: none;
            margin: 0; 
        }
        outline: none;
        background: transparent!important;
        border: none;
        color: white;
    }

    #alertQty{
        color: $rose;
        border-color: $rose;
        border-style: solid;
        text-align: center;
        font-size: 0.9rem;
    }

    #thumbnail-img {
        svg {
            max-height: 500px;
        }
    }

    .cart_quantity_down, .cart_quantity_up{
        border: 2px solid rgba(0,0,0,.5);
        border-radius: 10px;
        background-color: #fff;
        padding: 5px!important;
        width: 23px;
        height: 23px;
    }

    .price-block{
        position: absolute;
        bottom: 0;
        right: 0;
    }

    .number-product{
        height: 23px;
    }
</style>
